import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { PaytmCallbackData } from "src/models/payment.model";
import { transformPropsToLowerCase } from "src/utils/jsonObject.helper";
import { PaymentService } from "../payment/services/payment/payment.service";
import { CartItemService } from "../services/cart-item/cart-item.service";
import { OrderService } from "../services/order/order.service";
import { OrderAttributes } from "@models/order.model";
import { CartDetails, ProductCategories } from "@models/product.model";
import { ColorsPicker } from "~/src/utils/color-constants";
import { OrderItemAttributes } from "@models/orderItem.model";
import { finalize } from "rxjs";

@Component({
    selector: "order-success",
    templateUrl: "./order-success.component.html",
    styleUrls: ["./order-success.component.scss"],
    standalone: false,
})
export class OrderSuccessComponent implements OnInit {
    public callbackData!: PaytmCallbackData;
    public orderId!: number;
    public freeDeliveryAmount = 200;
    public orderDetails!: OrderAttributes;
    public categories = ProductCategories;
    public loading: boolean = false;

    constructor(
        private router: Router,
        private paymentService: PaymentService,
        private route: ActivatedRoute,
        private cartService: CartItemService,
        private orderService: OrderService,
        private cartItemService: CartItemService,
    ) {}

    ngOnInit(): void {
        this.callbackData = transformPropsToLowerCase(history.state);
        this.route.queryParams.subscribe((params) => {
            this.orderId = +params["orderId"];
            console.log(params);
            if (this.orderId) {
                this.getOrderDetails();
            }
        });
        this.RemoveAllCartItems(this.orderId);
        const merchantTransactionId = this.route.snapshot.paramMap.get("merchantTransactionId");
        if (merchantTransactionId) {
            this.paymentService.getPhonePePaymentStatus(merchantTransactionId).subscribe((response) => {
                this.callbackData.orderid = response.orderID.toString();
                this.orderId = +this.callbackData.orderid;
                if (this.orderId) {
                    this.getOrderDetails();
                }
                this.RemoveAllCartItems(this.orderId);
            });
        }
    }

    public RemoveAllCartItems(orderId: number): void {
        this.orderService.checkIsFromCart(orderId).subscribe((response) => {
            if (response.isFromCart) {
                this.cartService.removeAllCartItems().subscribe();
            }
        });
    }

    public onTrackOrder(): void {
        this.router.navigate([`account/trackOrder`]);
    }

    public onContinueShopping(): void {
        this.router.navigate(["home"]);
    }

    public getOrderDetails(): void {
        this.loading = true;
        this.orderService
            .getOrderById(this.orderId.toString())
            .pipe(finalize(() => (this.loading = false)))
            .subscribe({
                next: (response) => {
                    if (response) {
                        this.orderDetails = response;
                    }
                },
                error: (error) => {
                    throw error;
                },
            });
    }

    public getProducts(): OrderItemAttributes[] {
        return this.orderDetails.orderItems!;
    }

    public getFacesByType(data: OrderItemAttributes, type: string): string[] {
        return this.cartItemService.getFacesByType(data.singleBlockInfoDirectBuy!, type);
    }

    public getFaceColors(colorObject: object | undefined): { key: string; value: string }[] {
        if (!colorObject) {
            return [];
        }
        return Object.entries(colorObject).map(([key, value]) => ({
            key,
            value: value as string, // Ensure the value is treated as a string
        }));
    }

    public getColorValue(color: string): string | undefined {
        return ColorsPicker.find((c) => c.name === color)?.value;
    }

    public gotoProducts(): void {
        this.router.navigate(["products"]);
    }

    public gotoOrder(): void {
        this.router.navigate([`account/orders/${this.orderId}/orderInfo`]);
    }
}
